window.TUCSideMenu = SideMenu.extend({

    showMenu: function(isShowMenu) {
        var self = this;
        if (isShowMenu) {
            TweenLite.to(
                this.$el,
                0.3, {
                    width: SideMenu.VERTICAL_WIDTH,
                    onComplete: function() {
                        self.$el.show();
                    }
                }
            );
            this.moveContainer(true);
            this.isMenuOpen = true;
        } else {
            this.$el.hide();
            TweenLite.to(
                this.$el,
                0.3, {
                    width: "0px"
                }
            );
            this.moveContainer(false);
            this.isMenuOpen = false;
        }
    },

    moveContainer: function(isShow) {
        var props = {};
        props.left = isShow ? SideMenu.VERTICAL_WIDTH : "0px";

        if (!isShow) props.clearProps = "all";

        TweenLite.to(
            $(this.container.dom),
            0.3,
            props
        );

    },

    updateAudioButton: function() {
        // do nothing
    },

    getData: function() {
        var data = {};
        data.buttons = [];

        data.buttons.push({
            id: "helpnavigation",
            icon: "icon-help",
            type: "btn",
            labels: LanguageManager.getString('help'),
            clickHandler: this.handleHelpClick
        });

        return data;
    },

    updateAudioButton: function() {}
});
